import { render, staticRenderFns } from "./AppStep.vue?vue&type=template&id=5f4b61d2&scoped=true&"
var script = {}
import style0 from "./AppStep.vue?vue&type=style&index=0&id=5f4b61d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4b61d2",
  null
  
)

export default component.exports